import { render, staticRenderFns } from "./Wp_article_markdown.vue?vue&type=template&id=02fed58b&scoped=true&"
import script from "./Wp_article_markdown.vue?vue&type=script&lang=js&"
export * from "./Wp_article_markdown.vue?vue&type=script&lang=js&"
import style0 from "./Wp_article_markdown.vue?vue&type=style&index=0&id=02fed58b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fed58b",
  null
  
)

export default component.exports